<template>
  <div>
    <div class="card card-custom mb-5">
      <div class="card-header h-auto py-2">
        <div class="card-title">
          <h3 class="card-label">
            User
          </h3>
        </div>
        <div class="card-toolbar">
          <button class="align-self-start btn btn-sm btn-secondary mx-1" type="button" @click="saveUser" ref="submitUser" >Save User</button>
        </div>
      </div>
      <div class="card-body py-4">
        <div class="row">
          <div class="col-12">
            <div class="form-group row my-1">
              <label class="col-1 col-sm-2 col-form-label">Username:</label>
              <div class="col-5 col-sm-4">
                <span class="form-control-plaintext">{{currentItem.UserData.UserName}}</span>
              </div>
              <label class="col-1 col-sm-2 col-form-label">UserId:</label>
              <div class="col-5 col-sm-4">
                <span class="form-control-plaintext">{{currentItem.UserData.UserId}}</span>
              </div>
            </div>
            <div class="row my-1">
              <b-form-textarea
                  v-model="currentItem.UserData.Metadata"
                  class="form-control form-control-solid h-auto py-3 px-3 mt-2 mb-2"
                  max-rows="5"
                  name="UserMetadata"
                  placeholder="User Metadata"
                  rows="5"
                  size="sm"
              ></b-form-textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card card-custom mb-5">
      <div class="card-header h-auto py-2">
        <div class="card-title">
          <h3 class="card-label">
            Business
          </h3>
        </div>
        <div class="card-toolbar">
          <button class="align-self-start btn btn-sm btn-secondary mx-1" type="button" @click="saveBusiness" ref="submitBusiness" >Save Business</button>
        </div>
      </div>
      <div class="card-body py-4">
        <div class="row">
          <div class="col-12">
            <div class="form-group row my-1">
              <label class="col-1 col-sm-2 col-form-label">BusinessName:</label>
              <div class="col-5 col-sm-4">
                <span class="form-control-plaintext">{{currentItem.BusinessData.BusinessName}}</span>
              </div>
              <label class="col-1 col-sm-2 col-form-label">Branch Code:</label>
              <div class="col-5 col-sm-4">
                <span class="form-control-plaintext">{{currentItem.BusinessData.BranchCode}}</span>
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-1 col-sm-2 col-form-label">TIN:</label>
              <div class="col-5 col-sm-4">
                <span class="form-control-plaintext">{{currentItem.BusinessData.TIN}}</span>
              </div>
              <label class="col-1 col-sm-2 col-form-label">RDO:</label>
              <div class="col-5 col-sm-4">
                <span class="form-control-plaintext">{{currentItem.BusinessData.RDO}}</span>
              </div>
            </div>
            <div class="row my-1">
              <b-form-textarea
                  v-model="currentItem.BusinessData.Metadata"
                  class="form-control form-control-solid h-auto py-3 px-3 mt-2 mb-2"
                  max-rows="5"
                  name="BusinessMetadata"
                  placeholder="Business Metadata"
                  rows="5"
                  size="sm"
              ></b-form-textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";
import Swal from "sweetalert2";

Vue.use(require("vue-moment"));
Vue.filter("numFormat", numFormat(numeral));

Vue.use(require("vue-moment"));
export default {
  components: {},
  props: ["propdata"],
  data() {
    return {
      isBusy: false,
      tabIndex: 0,
      currentItem: {}
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData();
      this.setBreadcrumbs(
        this.propdata.Username
      );
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Easy Receipt",
          route: "/easyreciept"
        },
        {
          title: "Users",
          route: "/easyreceipt/adminusers"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    getData() {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = { id: self.propdata.UserId };
        ApiService.get("user/getfulldatabyid", param)
          .then(({ data }) => {
            this.$gtag.event("user_getfulldatabyid");
            self.isBusy = false;
            if (data) {
              self.currentItem = data;
            }
            resolve(data);
          })
          .catch(({ response }) => {
            self.isBusy = false;
            reject(response);
          });
      });
    },
    saveUser() {
      let self = this;
      self.isBusy = true;
      let param = self.currentItem.UserData;
      const submitButton = self.$refs["submitUser"];

      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      ApiService.post("user/updatemetadata", param)
          .then(({ data }) => {
            this.$gtag.event("user_updatemetadata", param);
            if (data) {
              self.isBusy = false;
              submitButton.classList.remove(
                  "spinner",
                  "spinner-light",
                  "spinner-right"
              );
              Swal.fire({
                title: "",
                text: "The User data has been successfully submitted!",
                icon: "success",
                confirmButtonClass: "btn btn-secondary"
              });
            }
          })
          .catch(() => {
            self.isBusy = false;
            submitButton.classList.remove(
                "spinner",
                "spinner-light",
                "spinner-right"
            );
          });
    },
    saveBusiness() {
      let self = this;
      self.isBusy = true;
      let param = self.currentItem.BusinessData;
      const submitButton = self.$refs["submitBusiness"];

      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      ApiService.post("business/updatemetadata", param)
          .then(({ data }) => {
            this.$gtag.event("business_updatemetadata", param);
            if (data) {
              self.isBusy = false;
              submitButton.classList.remove(
                  "spinner",
                  "spinner-light",
                  "spinner-right"
              );
              Swal.fire({
                title: "",
                text: "The Business data has been successfully submitted!",
                icon: "success",
                confirmButtonClass: "btn btn-secondary"
              });
            }
          })
          .catch(() => {
            self.isBusy = false;
            submitButton.classList.remove(
                "spinner",
                "spinner-light",
                "spinner-right"
            );
          });
    }
  },
  watch: {}
};
</script>

<style>
.col-form-label,
.form-control-plaintext {
  padding-top: 0px;
  padding-bottom: 0px;
}

.card.card-custom > .card-header {
  min-height: 50px;
}
</style>
